const DEFAULT_LANG = 'pt-BR';

export const PERCENT_INPUT_MAX = 100;
export const PERCENT_DRAFT_MAX_DECIMAL_PLACES = 3;

/**
 * Sanitiza o rascunho do campo % durante a digitação.
 * Limita dígitos inteiros ao teto percentual e a até 3 casas decimais.
 */
export function sanitizePercentDraft(
  raw: string,
  maxPercent: number = PERCENT_INPUT_MAX
): string {
  const cleaned = raw.replace(/[^0-9.,]/g, '');
  if (!cleaned) return '';

  const maxIntDigits = Math.max(1, String(Math.floor(maxPercent)).length);
  const sepIndex = cleaned.search(/[.,]/);

  if (sepIndex === -1) {
    return cleaned.slice(0, maxIntDigits);
  }

  const sep = cleaned[sepIndex];
  const intPart = cleaned.slice(0, sepIndex).slice(0, maxIntDigits);
  const decPart = cleaned
    .slice(sepIndex + 1)
    .replace(/[.,]/g, '')
    .slice(0, PERCENT_DRAFT_MAX_DECIMAL_PLACES);

  if (decPart.length > 0) {
    return `${intPart}${sep}${decPart}`;
  }

  if (cleaned.endsWith(sep)) {
    return `${intPart}${sep}`;
  }

  return intPart;
}

export function formatPercentInputValue(
  raw: string,
  max: number = PERCENT_INPUT_MAX
): string {
  const cleaned = raw.replace(/[^0-9.,]/g, '');
  if (!cleaned) return '';

  const normalized = cleaned.replace(',', '.');
  const parsed = parseFloat(normalized);
  if (Number.isFinite(parsed) && parsed > max) {
    return String(max);
  }

  const digitsOnly = cleaned.replace(/[^\d]/g, '');
  if (digitsOnly.length >= 3) {
    const intPart = parseInt(digitsOnly, 10);
    if (Number.isFinite(intPart) && intPart > max) {
      return String(max);
    }
  }

  return cleaned;
}

export function formatPercent(
  raw: string | number,
  lang: string = DEFAULT_LANG
): string {
  const value =
    typeof raw === 'number'
      ? raw
      : parseInt((raw || '').replace(/\D/g, ''), 10) / 100 || 0;

  return value.toLocaleString(lang, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
